import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Apollo, ApolloBase, gql } from 'apollo-angular';
import { ImportsRunnerPayload } from 'exports/interfaces/imports-runner.interface';
import { map } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ImportsRunnerService {
    private apollo: ApolloBase;

    constructor(
        private http: HttpClient,
        private apolloProvider: Apollo,
    ) {
        this.apollo = this.apolloProvider.use('listingAPI');
    }

    startBulkImport(payload: ImportsRunnerPayload) {
        const url = `${environment.BASE_URL}userApi/bulkOperation/start-bulk-import`;
        return this.http.post(url, payload);
    }

    getSupplierListingsForSyncImport(supplierId: string, brandId: string) {
        const query = `query getListings {
            listings {
                searchListings(searchQuery: {
                    pageNumber: 1,
                    pageSize: 10000,
                    orderBy: "name"
                    },
                    filtering: {
                        companyName: "${supplierId}"
                        brandId: "${brandId}"
                }) {
                    data {
                        id
                        shijiId
                        name
                    }
                }
            }
        }`;

        return this.apollo
            .query({
                query: gql(query),
                fetchPolicy: 'no-cache',
            })
            .pipe(
                map((response: any) => {
                    return response.data.listings.searchListings.data;
                }),
            );
    }
}
